if(!customElements.get('header-component')) {
  customElements.define(
    'header-component',
    class HeaderComponent extends HTMLElement {
      /** @type {HTMLElement | null} */
      #group;

      /** @type {number} */
      #lastScroll;
      
      constructor() {
        super();
      }

      connectedCallback() {
        this.#group = this.closest('#header-group');
        this.#lastScroll = 0;
        this.init();
      }

      init() {
        window.addEventListener(
          'scroll', 
          this.hideOrNotOnScroll.bind(this)
        );
      }

      hideOrNotOnScroll() {
        if(!this.#group) return;
        
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if(currentScroll > this.#lastScroll && currentScroll > this.#group.offsetHeight) {
          this.#group.classList.add('hide');
        } else {
          this.#group.classList.remove('hide');
        }

        this.#lastScroll = currentScroll <= 0 ? 0 : currentScroll;
      }
    }
  );
}